import { useEffect, useMemo, useRef } from 'react';
import { Icon, Link, useTranslation } from '@weareconceptstudio/core';

//* Style
import ButtonStyle from './style';

const Button = ({
	btnType,
	text,
	className,
	onClick,
	url,
	type = 'button',
	disabled = false,
	children,
	external = undefined,
	ariaLabel,
	iconName,
}) => {
	//! Ref
	const innerTextWrap = useRef();
	const contentWrapper = useRef();

	const { translate } = useTranslation();

	const Component = useMemo(() => (url ? Link : 'button'), [url]);
	const customProps = useMemo(() => (url ? { url, external } : { type, disabled }), [url, external, type, disabled]);

	let btn;

	useEffect(() => {
		if (contentWrapper.current) {
			contentWrapper.current.style.cssText = `
				--sizeText:${innerTextWrap.current.clientWidth + 'px'}
			`;
		}
	}, []);

	switch (btnType) {
		case 'primary':
		case 'primary-icon':
		case 'tertiary':
			btn = (
				<ButtonStyle
					onClick={!disabled && onClick ? onClick : null}
					className={`btn-${btnType} ${className || ''} ${disabled ? 'disabled' : ''} button`}>
					<div className='outside-wrapper-button'>
						<Component
							className='p p2 grotesk-500'
							{...customProps}>
							<span className='text'>{children || translate(text)}</span>
							{iconName && <Icon name={iconName} />}
						</Component>
					</div>
				</ButtonStyle>
			);
			break;
		case 'secondary':
			btn = (
				<ButtonStyle
					onClick={!disabled && onClick ? onClick : null}
					className={`btn-${btnType} ${className || ''} ${disabled ? 'disabled' : ''}`}>
					<div
						ref={contentWrapper}
						className='content-wrapper'>
						<div className='outside-wrapper-button'>
							<Component
								className='p p2 funnel-500'
								{...customProps}>
								<div
									ref={innerTextWrap}
									className='inner-text-wrap'>
									{children || translate(text)}
								</div>
							</Component>
						</div>

						<Icon name={iconName || 'arrow'} />
					</div>
				</ButtonStyle>
			);

			break;

		default:
			btn = (
				<ButtonStyle
					onClick={!disabled && onClick ? onClick : null}
					className={`btn ${className || ''} ${disabled ? 'disabled' : ''}`}>
					<Component
						{...ariaLabel}
						{...customProps}>
						{children || translate(text)}
					</Component>
				</ButtonStyle>
			);
	}

	return btn;
};

export default Button;
